import { render } from "./DisplayCurrencyValue.vue?vue&type=template&id=11002aa6"
import script from "./DisplayCurrencyValue.vue?vue&type=script&lang=js"
export * from "./DisplayCurrencyValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__